import { RequestDraftRoute, RequestDraftStatus } from '@prisma/client';

import { Draft } from '../../components/RequestDrafts/types';
import { trpc } from '../../config/trpc';

export type UseRequestDraft = {
  draft?: Draft;
  isPending: boolean;
  isBookingConfirmation: boolean;
  /**
   * Routes the review pane has no dedicated view for. Everything except BookingConfirmation today — those drafts render
   * read-only.
   */
  isUnsupportedRoute: boolean;
};

/** Fetches a draft and derives the route/status flags the review pane branches on. */
export const useRequestDraft = (draftId: number | null): UseRequestDraft => {
  const { data: draft } = trpc.getRequestDraft.useQuery({ id: draftId as number }, { enabled: draftId !== null });

  const isBookingConfirmation = draft?.route === RequestDraftRoute.BookingConfirmation;
  const isUnsupportedRoute = !!draft && !isBookingConfirmation;
  const isPending = draft?.status === RequestDraftStatus.Pending;

  return { draft, isPending, isBookingConfirmation, isUnsupportedRoute };
};
